import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import productSearchQuery from '~/graphql/productSearch.gql';
import productSearchAlgolia from '~/graphql/productSearchAlgolia.gql';
import { buildCategoryProductsQuery as buildAlgoliaCategoryProductsQuery } from '~/helpers/algolia-extract-helper';
import { buildCategoryProductsQuery } from '~/helpers/extract-helper';
import SEARCH_PROVIDER from '~/helpers/search-data-helpers';
function fetchCorvusAlgoliaSearch(_x, _x2, _x3, _x4) {
  return _fetchCorvusAlgoliaSearch.apply(this, arguments);
}
function _fetchCorvusAlgoliaSearch() {
  _fetchCorvusAlgoliaSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, keyword, query, withMarketplace) {
    var locale, algoliaUserToken, _buildAlgoliaCategory, offset, limit, sortBy, orderBy, filterBy, page, algoliaFilters, _yield$context$app$ap, productSearch, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          locale = context.state.i18n.currentLocale.iso;
          algoliaUserToken = context.$cookies.get('_ALGOLIA') || '';
          _buildAlgoliaCategory = buildAlgoliaCategoryProductsQuery(query), offset = _buildAlgoliaCategory.offset, limit = _buildAlgoliaCategory.limit, sortBy = _buildAlgoliaCategory.sortBy, orderBy = _buildAlgoliaCategory.orderBy, filterBy = _buildAlgoliaCategory.filterBy, page = _buildAlgoliaCategory.page, algoliaFilters = _buildAlgoliaCategory.algoliaFilters;
          _context.next = 5;
          return context.app.apolloProvider.defaultClient.query({
            query: productSearchAlgolia,
            variables: {
              variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
              locale: locale,
              keyword: keyword,
              offset: offset,
              limit: limit,
              sortBy: sortBy,
              orderBy: orderBy,
              filterBy: filterBy,
              page: page,
              algoliaFilters: algoliaFilters,
              algoliaUserToken: algoliaUserToken,
              withMarketplace: withMarketplace
            }
          });
        case 5:
          _yield$context$app$ap = _context.sent;
          productSearch = _yield$context$app$ap.data.productSearchAlgolia;
          response = {
            productSearch: productSearch
          };
          return _context.abrupt("return", response);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchCorvusAlgoliaSearch.apply(this, arguments);
}
function fetchElasticSearch(_x5, _x6, _x7) {
  return _fetchElasticSearch.apply(this, arguments);
}
function _fetchElasticSearch() {
  _fetchElasticSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, keyword, query) {
    var locale, _buildCategoryProduct, offset, limit, sortBy, orderBy, filterBy, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          locale = context.state.i18n.currentLocale.iso;
          _buildCategoryProduct = buildCategoryProductsQuery(query), offset = _buildCategoryProduct.offset, limit = _buildCategoryProduct.limit, sortBy = _buildCategoryProduct.sortBy, orderBy = _buildCategoryProduct.orderBy, filterBy = _buildCategoryProduct.filterBy;
          _context2.next = 4;
          return context.app.apolloProvider.defaultClient.query({
            query: productSearchQuery,
            variables: {
              variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
              locale: locale,
              keyword: keyword,
              offset: offset,
              limit: limit,
              sortBy: sortBy,
              orderBy: orderBy,
              filterBy: filterBy
            }
          });
        case 4:
          response = _context2.sent;
          return _context2.abrupt("return", response.data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchElasticSearch.apply(this, arguments);
}
function fetchSearch(_x8, _x9, _x10, _x11) {
  return _fetchSearch.apply(this, arguments);
}
function _fetchSearch() {
  _fetchSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context, keyword, query, withMarketplace) {
    var searchResponse, _searchResponse, _searchResponse$produ, _searchResponse2, _searchResponse2$prod, canRunAlgolia;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(SEARCH_PROVIDER(context) === 'algolia')) {
            _context3.next = 7;
            break;
          }
          _context3.next = 3;
          return fetchCorvusAlgoliaSearch(context, keyword, query, withMarketplace);
        case 3:
          searchResponse = _context3.sent;
          canRunAlgolia = ((_searchResponse = searchResponse) === null || _searchResponse === void 0 ? void 0 : (_searchResponse$produ = _searchResponse.productSearch) === null || _searchResponse$produ === void 0 ? void 0 : _searchResponse$produ.products.length) || ((_searchResponse2 = searchResponse) === null || _searchResponse2 === void 0 ? void 0 : (_searchResponse2$prod = _searchResponse2.productSearch) === null || _searchResponse2$prod === void 0 ? void 0 : _searchResponse2$prod.details.redirect);
          if (!canRunAlgolia) {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return", searchResponse);
        case 7:
          searchResponse = fetchElasticSearch(context, keyword, query);
          return _context3.abrupt("return", searchResponse);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchSearch.apply(this, arguments);
}
export default fetchSearch;